import { Injectable } from '@angular/core';
import { TypeDelais } from '../../models/TypeDelais';
import { Validite } from '../../models/TypeValidite';

@Injectable({
  providedIn: 'root'
})
export class TypeDelaisService {

  constructor() {
  }

  getTypeDelais(controls) {
    const typeDelais = new TypeDelais();

    typeDelais.envoiInvitation = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeDelais_SepAtt_envoiInvitation'));
    typeDelais.receptCandidatures = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptCandidatures'));
    typeDelais.receptionOffres = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeDelais_SepAtt_receptionOffres'));
    typeDelais.validite = new Validite();
    typeDelais.validite.dateJusquau = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeDelais_SepSep_Validite_SepAtt_dateJusquau'));
    typeDelais.validite.nbJours = controls.get('_SepSep_Initial_SepSep_TypeDelais_SepSep_Validite_SepAtt_nbJours');
    typeDelais.validite.nbMois = controls.get('_SepSep_Initial_SepSep_TypeDelais_SepSep_Validite_SepAtt_nbMois');

    return typeDelais;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
